import React, { useState, useEffect } from 'react';
import layoutEngine from '../libraries/layoutEngine';
import ProjectManager from '../canvas/ProjectManager';
import ToolManager from '../libraries/ToolManager';

const InstanceInsertForm = ({ onClose }) => {
  const [availableCells, setAvailableCells] = useState([]);
  const [selectedCell, setSelectedCell] = useState('');
  const [x, setX] = useState('');
  const [y, setY] = useState('');
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const names = layoutEngine.getAllCellNames();
    console.log("Available cell names:", names);
    setAvailableCells(names.filter(name => name !== ProjectManager.getSelectedCell()));
  }, []);

  const handleInsert = () => {
    if (!selectedCell) return;
  
    ProjectManager.setSelectedInstanceCell(selectedCell);
  
    const canvas = window.canvasEngine;
    if (!canvas) return;
  
    // 1️⃣ Tool change to instance
    ToolManager.setTool("instance");
    window.dispatchEvent(new CustomEvent("tool-changed", { detail: "instance" }));
  
    // 2️⃣ Initial preview
    const pointer = canvas.lastPointer || { x: 0, y: 0 };
    const x = canvas.snapToGrid(pointer.x);
    const y = canvas.snapToGrid(pointer.y);
    canvas.previewInstance = { ref: selectedCell, x, y }; // ✅ use selectedCell as ref
    canvas.draw();
  
    // 3️⃣ Close form
    onClose();
  };
  
  
  

  return (
    <div style={{ background: '#222', padding: 10, color: 'white', borderRadius: 6 }}>
      <label>Select cell to insert:</label>
      <select
        value={selectedCell}
        onChange={(e) => setSelectedCell(e.target.value)}
        style={{ marginLeft: 10 }}
      >
        <option value="">-- Select --</option>
        {availableCells.map((cellName) => (
          <option key={cellName} value={cellName}>
            {cellName}
          </option>
        ))}
      </select>

      <div style={{ marginTop: 10 }}>
        <label>X:</label>
        <input type="number" value={x} onChange={(e) => setX(e.target.value)} style={{ width: 60, marginRight: 10 }} />

        <label>Y:</label>
        <input type="number" value={y} onChange={(e) => setY(e.target.value)} style={{ width: 60, marginRight: 10 }} />

        <label>Rotation:</label>
        <input type="number" value={rotation} onChange={(e) => setRotation(e.target.value)} style={{ width: 60 }} />
      </div>

      <button onClick={handleInsert} style={{ marginTop: 10, padding: '4px 12px' }}>
        ➕ Insert
      </button>
    </div>
  );
};

export default InstanceInsertForm;
